import { z } from 'zod/v4';
import {
  FullCompanySchema,
  UserCompanyListRowSchema,
} from '../../../../companies/index.js';
import { EnabledPlatformFeatureSchema } from '../../../../platform-features/index.js';

export const AdminUserImpersonateParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminUserImpersonateParams = z.infer<
  typeof AdminUserImpersonateParamsSchema
>;

export const AdminUserImpersonateQuerySchema = z.object({
  companyId: z.string().optional(),
});

export type AdminUserImpersonateQuery = z.infer<
  typeof AdminUserImpersonateQuerySchema
>;

const EnabledDevelopmentTagSchema = z.object({
  featureId: z.string(),
  tag: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  isEnabled: z.number(),
});

/**
 * Row shape returned by the admin impersonate endpoint. `looseObject` because
 * the underlying legacy `users` table has ~25 columns and this response is
 * stored verbatim as the frontend's global auth `me` object — adding strict
 * typing here would duplicate that shape without buying validation strength.
 */
export const AdminUserImpersonateResponseSchema = z.looseObject({
  id: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string().nullable(),
  primaryCompanyId: z.string().nullable(),
  companyId: z.string().optional(),
  company: FullCompanySchema.extend({
    enabledFeatures: z.array(EnabledPlatformFeatureSchema),
  }).optional(),
  userCompanies: z.array(UserCompanyListRowSchema),
  appFeatures: z.array(z.unknown()),
  preferences: z.record(z.string(), z.unknown()),
  enabledDevelopmentTags: z.array(EnabledDevelopmentTagSchema),
});

export type AdminUserImpersonateResponse = z.infer<
  typeof AdminUserImpersonateResponseSchema
>;
